"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1675],{

/***/ 42843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ PercentageIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function PercentageIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 24,
        height: props.size || 24,
        viewBox: "0 0 14.984 15.292"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            transform: "translate(0 0)",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                    className: "a",
                    fill: props.color || "#000000",
                    cx: "0.639",
                    cy: "0.639",
                    rx: "0.639",
                    ry: "0.639",
                    transform: "translate(4.821 5.708)"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                    className: "a",
                    fill: props.color || "#000000",
                    cx: "0.639",
                    cy: "0.639",
                    rx: "0.639",
                    ry: "0.639",
                    transform: "translate(8.882 8.303)"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: props.color,
                    className: "a",
                    d: "M19.711,8.49l-.232-.316a1,1,0,0,1-.009-1.163l.226-.32a1,1,0,0,0-.345-1.454l-.345-.185a.993.993,0,0,1-.511-1.043l.066-.385a1,1,0,0,0-.94-1.159l-.392-.016a1,1,0,0,1-.915-.718l-.11-.376A.993.993,0,0,0,14.854.719l-.36.154A.993.993,0,0,1,13.359.622L13.1.331a.993.993,0,0,0-1.492.013l-.257.295A1,1,0,0,1,10.22.9L9.856.754a1,1,0,0,0-1.341.658l-.1.379a.989.989,0,0,1-.9.73l-.392.022A1,1,0,0,0,6.2,3.718l.072.385a.993.993,0,0,1-.5,1.05l-.342.191A.994.994,0,0,0,5.112,6.8l.232.316A1,1,0,0,1,5.353,8.28l-.226.32a1,1,0,0,0,.345,1.454l.345.185a.993.993,0,0,1,.511,1.043l-.066.385a1,1,0,0,0,.94,1.159l.392.016a1,1,0,0,1,.915.718l.11.376a.993.993,0,0,0,1.351.636l.36-.154a.993.993,0,0,1,1.134.251l.26.291a.993.993,0,0,0,1.492-.013l.257-.295a1,1,0,0,1,1.131-.266l.363.15a1,1,0,0,0,1.341-.658l.1-.379a.989.989,0,0,1,.9-.73l.392-.022a1,1,0,0,0,.921-1.175l-.072-.385a.993.993,0,0,1,.5-1.05l.342-.191A.993.993,0,0,0,19.711,8.49ZM8.835,6.347a1.542,1.542,0,1,1,1.542,1.542A1.541,1.541,0,0,1,8.835,6.347Zm1.839,3.976a.377.377,0,0,1-.53.05h0a.377.377,0,0,1-.05-.53l4.045-4.873a.376.376,0,1,1,.58.479Zm3.766.16a1.542,1.542,0,1,1,1.542-1.542A1.541,1.541,0,0,1,14.44,10.483Z",
                    transform: "translate(-4.919 0)"
                })
            ]
        })
    }));
}


/***/ }),

/***/ 52479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AtomicComponents_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/Button.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  text-align: center;\n  outline: none;\n  border-width: ",
        ";\n  border-style: solid;\n  letter-spacing: 0.3px;\n  text-transform: ",
        ";\n  width: ",
        ";\n  ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        "px;\n  display: ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ";\n  border-color: ",
        ";\n  border-color: ",
        ";\n  ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ButtonBody = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ButtonBody",
    componentId: "sc-989935d2-0"
})(_templateObject(), function(props) {
    return props.borderWidth || "1px";
}, function(props) {
    return props.textTransform;
}, function(props) {
    return props.fluid ? "100%" : "fit-content";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.width) && "width : ".concat(props === null || props === void 0 ? void 0 : props.width);
}, function(props) {
    return props.fontWeight || 500;
}, function(props) {
    return props.fontSize || 14;
}, function(props) {
    return props.display || "block";
}, function(props) {
    return props.pt && "padding-top: ".concat(props.pt);
}, function(props) {
    return props.pb && "padding-bottom: ".concat(props.pb);
}, function(props) {
    return props.pl && "padding-left: ".concat(props.pl);
}, function(props) {
    return props.pr && "padding-right: ".concat(props.pr);
}, function(props) {
    return props.px && "\n      padding-left: ".concat(props.px, ";\n      padding-right: ").concat(props.px, ";\n    ");
}, function(props) {
    return props.py && "\n      padding-top: ".concat(props.py, ";\n      padding-bottom: ").concat(props.py, ";\n    ");
}, function(props) {
    return props.mt && "margin-top: ".concat(props.mt);
}, function(props) {
    return props.mb && "margin-bottom: ".concat(props.mb);
}, function(props) {
    return props.ml && "margin-left: ".concat(props.ml);
}, function(props) {
    return props.mr && "margin-right: ".concat(props.mr);
}, function(props) {
    return props.mx && "\n      margin-left: ".concat(props.mx, ";\n      margin-right: ").concat(props.mx, ";\n    ");
}, function(props) {
    return props.my && "\n      margin-top: ".concat(props.my).concat(props.my !== "auto" && "", ";\n      margin-bottom: ").concat(props.my).concat(props.my !== "auto" && "", ";\n    ");
}, function(props) {
    return props.maxWidth && "max-width: ".concat(props.maxWidth);
}, function(props) {
    return props.variant === "outline" ? "transparent" : props.backgroundColor || "#000000";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return props.variant === "outline" ? props.backgroundColor : props.fontColor || "#ffffff";
}, function(props) {
    return !props.disabled && props.boxShadow;
}, function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.borderColor;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.whiteSpace) && "white-space: ".concat(props === null || props === void 0 ? void 0 : props.whiteSpace);
}, function(props) {
    return props.hoverEnabled && "#F8F8F8";
}, function(props) {
    return props.isDisable && "opacity: 0.5";
});

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js







var Button = function(props) {
    var label = props.label, args = (0,_object_without_properties/* default */.Z)(props, [
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBody, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
        children: label
    }));
};
Button.propsTypes = {
    backgroundColor: (prop_types_default()).string,
    label: (prop_types_default()).string.isRequired,
    onClick: (prop_types_default()).any,
    display: (prop_types_default()).string,
    roundness: (prop_types_default()).number,
    width: (prop_types_default()).string,
    textTransform: (prop_types_default()).string,
    fontColor: (prop_types_default()).string,
    pt: (prop_types_default()).string,
    pl: (prop_types_default()).string,
    pb: (prop_types_default()).string,
    pr: (prop_types_default()).string,
    py: (prop_types_default()).string,
    px: (prop_types_default()).string,
    mt: (prop_types_default()).string,
    mb: (prop_types_default()).string,
    ml: (prop_types_default()).string,
    mr: (prop_types_default()).string,
    mx: (prop_types_default()).string,
    my: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    borderColor: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    fontSize: (prop_types_default()).number,
    variant: (prop_types_default()).string,
    whiteSpace: (prop_types_default()).string
};
/* harmony default export */ var AtomicComponents_Button = (Button);


/***/ }),

/***/ 38855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "WE": function() { return /* reexport */ CartButton/* default */.Z; },
  "rs": function() { return /* reexport */ AtomicComponents_Switch; }
});

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js + 1 modules
var Button = __webpack_require__(52479);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/index.js
var CartButton = __webpack_require__(8673);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/Switch.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  cursor: pointer;\n  box-sizing: border-box;\n  outline: none;\n  width: ",
        ";\n  outline: none;\n  background: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 12px;\n  background-color: #eeeef1;\n\n  color: #646464;\n  ",
        ";\n\n  width: ",
        ";\n  width: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    width: 100px;\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    width: 80px;\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  transform: translateY(-50%);\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 50%;\n  ",
        "\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 100%;\n  padding: 8px 12px;\n\n  border-top-left-radius: ",
        ";\n  border-bottom-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var SwitchContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchContainer",
    componentId: "sc-69b69fd5-0"
})(_templateObject(), function(props) {
    return props.fluid ? "100%" : "fit-content";
});
var switches = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "switches",
    componentId: "sc-69b69fd5-1"
})(_templateObject1(), function(props) {
    return props.fontSize || 14;
});
var SwitchLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchLabel",
    componentId: "sc-69b69fd5-2"
})(_templateObject2(), function(props) {
    return props.type === "left" ? "\n    border-top-left-radius: ".concat((0,util/* roundnessCalculator */.M)(props.roundness), ";\n    border-bottom-left-radius: ").concat((0,util/* roundnessCalculator */.M)(props.roundness), ";\n  ") : "\n    border-top-right-radius: ".concat((0,util/* roundnessCalculator */.M)(props.roundness), ";\n    border-bottom-right-radius: ").concat((0,util/* roundnessCalculator */.M)(props.roundness), ";\n  ");
}, function(props) {
    return props.width && "".concat(props.width, " !important;");
}, function(props) {
    return props.fluid && "100% !important;";
});
var SwitchToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchToggle",
    componentId: "sc-69b69fd5-3"
})(_templateObject3(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return !!props.isToggle ? "right: -5px;" : "left: -5px;";
});
var Toggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Toggle",
    componentId: "sc-69b69fd5-4"
})(_templateObject4(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness * 2);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/index.js



var Switch = function(props) {
    var firstText = props.firstText, secondText = props.secondText, _roundness = props.roundness, roundness = _roundness === void 0 ? 2 : _roundness, _fluid = props.fluid, fluid = _fluid === void 0 ? false : _fluid, backgroundColor = props.backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchContainer, {
        fluid: fluid,
        onClick: props.onClick,
        fontSize: 14,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchLabel, {
                fluid: fluid,
                width: props.width,
                type: "left",
                roundness: roundness,
                children: firstText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchLabel, {
                fluid: fluid,
                width: props.width,
                type: "right",
                roundness: roundness,
                children: secondText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchToggle, {
                roundness: roundness,
                isToggle: props.switchToggle,
                fontColor: props.fontColor,
                backgroundColor: backgroundColor,
                children: props.switchToggle ? secondText : firstText
            })
        ]
    });
};
/* harmony default export */ var AtomicComponents_Switch = (Switch);

;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/index.js






/***/ }),

/***/ 51675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PromoList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/assets/svgExports/PercentageIcon.js
var PercentageIcon = __webpack_require__(42843);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/ReactSlickCarousel/index.js
var ReactSlickCarousel = __webpack_require__(42783);
// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(68615);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts
var ssrStore = __webpack_require__(20155);
// EXTERNAL MODULE: ./src/services/store.ts
var store = __webpack_require__(8101);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(38855);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx + 1 modules
var Modal = __webpack_require__(90429);
;// CONCATENATED MODULE: ./src/components/PromoList/PromoDetailModalOld.tsx









var PromoDetailModalOld = function(param) {
    var promoId = param.promoId, onClose = param.onClose, bannerImage = param.bannerImage;
    var getPromoData = function getPromoData() {
        var params = {
            storeId: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            promoId: promoId
        };
        dispatch((0,promo/* getPromoDataById */.lT)(params, function(data) {
            setCoupon(data);
        }));
    };
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var ref1 = (0,react.useState)(null), coupon = ref1[0], setCoupon = ref1[1];
    var requiredLinksData = (coupon === null || coupon === void 0 ? void 0 : coupon.required_entity_chips) || [];
    var rewardListData = (coupon === null || coupon === void 0 ? void 0 : coupon.reward_entity_chips) || [];
    var ref2 = (0,react.useState)(false), showMoreRequired = ref2[0], setShowMoreRequired = ref2[1];
    var ref3 = (0,react.useState)(false), showMoreReward = ref3[0], setShowMoreReward = ref3[1];
    (0,react.useEffect)(function() {
        getPromoData();
    }, [
        promoId
    ]);
    var handleRequiredChipClick = function(url) {
        router.push((0,routes.getRoute)(url, storeData.store_info.domain));
    };
    var renderRequiredLinks = function(requiredLinks) {
        var totalRequiredLinks = requiredLinks === null || requiredLinks === void 0 ? void 0 : requiredLinks.length;
        return !!totalRequiredLinks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(deviceWidth/* deviceWidth */.o > 768 ? "f16px" : "f12px", " mt30px fw6 tw-flex"),
                    children: (coupon === null || coupon === void 0 ? void 0 : coupon.requirement_header_text) || ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-wrap tw-text-nowrap",
                    children: [
                        requiredLinks.slice(0, showMoreRequired ? totalRequiredLinks : 6).map(function(linkData, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                                px: "20px",
                                py: "5px",
                                fontSize: "12",
                                label: linkData === null || linkData === void 0 ? void 0 : linkData.text,
                                backgroundColor: "white",
                                fontColor: "#474748",
                                borderColor: "#DDDDDD",
                                roundness: 4,
                                mt: "12px",
                                mr: "5px",
                                hoverEnabled: true,
                                onClick: function(e) {
                                    e === null || e === void 0 ? void 0 : e.stopPropagation();
                                    handleRequiredChipClick(linkData === null || linkData === void 0 ? void 0 : linkData.url);
                                }
                            }, linkData.id);
                        }),
                        totalRequiredLinks > 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-flex tw-cursor-pointer tw-items-center tw-text-[13px]/[20px] tw-font-semibold",
                            onClick: function() {
                                return setShowMoreRequired(!showMoreRequired);
                            },
                            children: showMoreRequired ? "Less" : "More"
                        })
                    ]
                })
            ]
        });
    };
    var renderRewardChips = function(rewardChips) {
        var totalRewardChips = rewardChips === null || rewardChips === void 0 ? void 0 : rewardChips.length;
        return !!totalRewardChips && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: deviceWidth/* deviceWidth */.o > 768 ? "f16px fw6 tw-mt-[24px]" : "f12px fw6 tw-mt-[24px]",
                    children: (coupon === null || coupon === void 0 ? void 0 : coupon.reward_header_text) || ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-mt-[12px] tw-text-[12px] tw-font-medium",
                    children: [
                        rewardChips.slice(0, showMoreReward ? totalRewardChips : 6).map(function(rewardData) {
                            return (rewardData === null || rewardData === void 0 ? void 0 : rewardData.text) || "";
                        }).join(", "),
                        totalRewardChips > 6 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "tw-inline-flex tw-cursor-pointer tw-items-center tw-font-semibold",
                            onClick: function() {
                                return setShowMoreReward(!showMoreReward);
                            },
                            children: [
                                "...",
                                showMoreReward ? "Less" : "More"
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return coupon && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: true,
        height: 300,
        animation: "fadeIn",
        onClose: onClose,
        className: "couponDetails-overlay",
        customStyles: {
            top: "50%",
            left: "50%",
            bottom: "initial",
            right: "initial",
            transform: "translate(-50%, -50%)",
            width: "90%",
            borderRadius: "15px",
            maxWidth: "450px"
        },
        customMaskStyles: {
            background: "#000000e0"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "topdesign relative br4 br--top h4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: bannerImage || "/assets/images/bg-ribbon.png",
                    className: "h-100 w-100 br4",
                    alt: "Promo Code background",
                    loading: "lazy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-max-h-[420px] tw-overflow-scroll",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "details br4 br--bottom bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "f3 fw7 mt4 mb3",
                                children: coupon === null || coupon === void 0 ? void 0 : coupon.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ba b--black-20 br2 pa1 f6 b--dashed",
                                    children: [
                                        "Use Code: ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: coupon === null || coupon === void 0 ? void 0 : coupon.code
                                        })
                                    ]
                                })
                            }),
                            coupon === null || coupon === void 0 ? void 0 : (ref = coupon.offer_eligiblities) === null || ref === void 0 ? void 0 : ref.map(function(eligiblity, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "f7 black-100 mt3",
                                    children: eligiblity
                                }, index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex-col",
                        children: [
                            renderRequiredLinks(requiredLinksData),
                            renderRewardChips(rewardListData)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cross-icon absolute w-100 flex flex-column justify-center items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "white-70 f7 tc flex justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/images/ic_bulb.png",
                                alt: "bulb",
                                className: "img h1 mr2"
                            }),
                            " Use this coupon while placing an order"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "bg-white-20 h2 w2 br4 flex justify-center items-center pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/images/cancel_white.png",
                            alt: "cross",
                            className: " img h1",
                            onClick: onClose
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PromoList_PromoDetailModalOld = (PromoDetailModalOld);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
;// CONCATENATED MODULE: ./src/components/PromoList/index.js
/**
 * Promo List Component
 */ 












var PromoList = function(props) {
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    var sliderRef = (0,react.useRef)();
    var ref2 = (0,react.useState)(0), activeSlide = ref2[0], setActiveSlide = ref2[1];
    var ref3 = (0,react.useState)({
        show: false,
        promoId: null
    }), couponDetailOverlay = ref3[0], setCouponDetailOverlay = ref3[1];
    var ref4 = (0,react.useState)(""), bannerImage = ref4[0], setbannerImage = ref4[1];
    var ref5 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1, ref2;
        return {
            storeData: state.storeReducer.store,
            couponsList: state === null || state === void 0 ? void 0 : (ref = state.promoReducer) === null || ref === void 0 ? void 0 : ref.couponsList,
            isCustomWebsite: (ref1 = state.storeReducer.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.theme) === null || ref2 === void 0 ? void 0 : ref2.custom_theme_flag
        };
    }), storeData = ref5.storeData, couponsList = ref5.couponsList, isCustomWebsite = ref5.isCustomWebsite;
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    (0,react.useEffect)(function() {
        (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !(couponsList === null || couponsList === void 0 ? void 0 : couponsList.length) && isCustomWebsite && !isCouponsFeatureLocked && (0,store/* getCouponList */.KV)(storeData.store_id).then(function(data) {
            dispatch((0,promo/* saveCouponsList */.Kp)({
                coupons: data
            }));
        });
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        couponsList === null || couponsList === void 0 ? void 0 : couponsList.length,
        isCouponsFeatureLocked
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Body) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(layout) {
            var ref, ref1;
            if (layout.sub_type === "HeroBanner") setbannerImage((ref1 = (ref = layout.images) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
                return el.is_desktop === false;
            }).sort(function(a, b) {
                return a.order - b.order;
            })[0]) === null || ref1 === void 0 ? void 0 : ref1.image_url);
        });
    }, []);
    // do not show old promo slider if not custom website
    if (!isCustomWebsite) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    /**
   * Slider base values
   */ var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        centerMode: deviceWidth/* deviceWidth */.o > 990 ? false : true,
        slidesToShow: deviceWidth/* deviceWidth */.o > 990 ? 3 : 1,
        swipeToSlide: true,
        slidesToScroll: 1,
        initialSlide: 0,
        dotsClass: "dotted_icons",
        arrows: false,
        afterChange: function(current) {
            return setActiveSlide(current);
        }
    };
    /**
   * slider prev button
   * click handler function
   */ var onPrevClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickPrev) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickPrev();
        }
    };
    /**
   * slider next button
   * click handler function
   */ var onNextClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickNext) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickNext();
        }
    };
    /**
   * Helper function to toggle
   * the Coupon details overlay
   * @param {number} idx
   */ var onToggleCouponDetailsOverlay = function(promoId) {
        setCouponDetailOverlay(function(state) {
            return {
                show: !state.show,
                promoId: state.show === false ? promoId : null
            };
        });
    };
    var _renderCoupon2 = function(coupon, idx) {
        var ref, ref1, ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "coupon-card2 br3 relative flex",
            onClick: function() {
                return onToggleCouponDetailsOverlay(coupon === null || coupon === void 0 ? void 0 : coupon.id);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    color: "black",
                    height: "100%",
                    background: "linear-gradient(90deg, ".concat(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color, " 0%, ").concat(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color, " 30%, rgba(0,212,255,0) 100%)")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentageIcon/* PercentageIcon */.S, {
                        color: "#fff",
                        className: "absolute img h1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "left flex flex-column justify-center items-start white h-100 !tw-w-full tw-px-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "f5 mt0 mb1",
                                children: coupon === null || coupon === void 0 ? void 0 : coupon.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "codeText mv0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Use Code:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "f7 ",
                                        children: coupon === null || coupon === void 0 ? void 0 : coupon.code
                                    })
                                ]
                            })
                        ]
                    }),
                    !!bannerImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "promo code background",
                            src: bannerImage,
                            className: ""
                        })
                    })
                ]
            })
        }, idx);
    };
    var _renderCoupon3 = function(coupon, idx) {
        var ref, ref1, ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "coupon-card2 br3 relative flex",
            onClick: function() {
                return onToggleCouponDetailsOverlay(coupon === null || coupon === void 0 ? void 0 : coupon.id);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    color: "black",
                    height: "100%",
                    background: "linear-gradient(90deg, ".concat(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color, " 0%, ").concat(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color, " 30%, rgba(0,212,255,0) 100%)")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentageIcon/* PercentageIcon */.S, {
                        color: "#000",
                        className: "absolute img h1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "left flex flex-column justify-center items-start h-100 black !tw-w-full tw-px-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "f5 mt0 mb1",
                                children: coupon === null || coupon === void 0 ? void 0 : coupon.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "codeText mv0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Use Code:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "f7",
                                        children: coupon === null || coupon === void 0 ? void 0 : coupon.code
                                    })
                                ]
                            })
                        ]
                    }),
                    !!bannerImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "promo code background",
                            src: bannerImage,
                            className: ""
                        })
                    })
                ]
            })
        }, idx);
    };
    var _renderCoupon4 = function(coupon, idx) {
        var ref, ref1, ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "coupon-card4 br3 relative flex",
            onClick: function() {
                return onToggleCouponDetailsOverlay(coupon === null || coupon === void 0 ? void 0 : coupon.id);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    color: "black",
                    height: "100%",
                    background: "linear-gradient(90deg, ".concat(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color, " 0%, ").concat(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color, " 30%, rgba(0,212,255,0) 100%)")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentageIcon/* PercentageIcon */.S, {
                        color: "#fff",
                        className: "absolute img h1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "left flex flex-column justify-center items-start white h-100 !tw-w-full tw-px-[32px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "f6 mt0 mb1",
                                children: coupon === null || coupon === void 0 ? void 0 : coupon.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "codeText mv0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Use Code:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "f7 ",
                                        children: coupon === null || coupon === void 0 ? void 0 : coupon.code
                                    })
                                ]
                            })
                        ]
                    }),
                    !!bannerImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "promo code background",
                            src: bannerImage,
                            className: ""
                        })
                    })
                ]
            })
        }, idx);
    };
    var _renderCoupon5 = function(coupon, idx) {
        var ref, ref1, ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "coupon-card4 br3 relative flex",
            onClick: function() {
                return onToggleCouponDetailsOverlay(coupon === null || coupon === void 0 ? void 0 : coupon.id);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    color: "black",
                    height: "100%",
                    background: "linear-gradient(90deg, ".concat(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color, " 0%, ").concat(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color, " 30%, rgba(0,212,255,0) 100%)")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentageIcon/* PercentageIcon */.S, {
                        alt: "percentage",
                        color: "#000",
                        className: "absolute img h1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "left flex flex-column justify-center items-start black h-100 !tw-w-full tw-px-[32px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "f6 mt0 mb1",
                                children: coupon === null || coupon === void 0 ? void 0 : coupon.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "codeText mv0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Use Code:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "f7",
                                        children: coupon === null || coupon === void 0 ? void 0 : coupon.code
                                    })
                                ]
                            })
                        ]
                    }),
                    !!bannerImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "promo code background",
                            src: bannerImage,
                            loading: "lazy",
                            className: ""
                        })
                    })
                ]
            })
        }, idx);
    };
    var _renderCoupon1 = function(coupon, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "coupon-card1 br3 relative tw-h-full",
            onClick: function() {
                return onToggleCouponDetailsOverlay(coupon === null || coupon === void 0 ? void 0 : coupon.id);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentageIcon/* PercentageIcon */.S, {
                    color: "#EA5151"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "f5 mt0 mb1",
                    children: coupon === null || coupon === void 0 ? void 0 : coupon.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "flex justify-start items-center f7 mv0 flamingo-color",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Use Code:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "f6 ml1 ",
                            children: coupon === null || coupon === void 0 ? void 0 : coupon.code
                        })
                    ]
                })
            ]
        }, idx);
    };
    var _renderCoupons = function(coupon, idx, cardNumer) {
        cardNumer = 2;
        switch(cardNumer){
            case 2:
                return _renderCoupon2(coupon, idx);
            case 3:
                return _renderCoupon3(coupon, idx);
            case 4:
                return _renderCoupon4(coupon, idx);
            case 5:
                return _renderCoupon5(coupon, idx);
            default:
                return _renderCoupon1(coupon, idx);
        }
    };
    return (couponsList === null || couponsList === void 0 ? void 0 : couponsList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "promoList bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "header flex justify-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "promoList__title fw6 tc center mv0",
                    children: "Offers"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "header flex justify-between",
                        children: settings.slidesToShow < couponsList.length && deviceWidth/* deviceWidth */.o > 990 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "action-wrapper flex justify-center items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/arrowb.png",
                                    className: "img h1 mr2 ".concat(activeSlide === 0 && "o-20"),
                                    onClick: onPrevClick,
                                    alt: "prev arrow"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/arrowf.png",
                                    className: "img h1 mr2 ".concat((activeSlide === couponsList.length - 1 || activeSlide === couponsList.length - settings.slidesToShow) && "o-20"),
                                    onClick: onNextClick,
                                    alt: "next arrow"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactSlickCarousel/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: function(slider) {
                            return sliderRef.current = slider;
                        }
                    }, settings), {
                        children: couponsList === null || couponsList === void 0 ? void 0 : couponsList.map(function(coupon, idx) {
                            return _renderCoupons(coupon, idx, props.cardNumer || 1);
                        })
                    })),
                    deviceWidth/* deviceWidth */.o < 990 && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "flex justify-center items-center mt2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("progress", {
                            max: couponsList.length - 1,
                            value: activeSlide,
                            className: "slider-scrollbar bg-grey",
                            style: {
                                color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) || "#ea5151"
                            }
                        })
                    }),
                    couponDetailOverlay.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoList_PromoDetailModalOld, {
                        promoId: couponDetailOverlay.promoId,
                        onClose: onToggleCouponDetailsOverlay,
                        bannerImage: bannerImage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_PromoList = (PromoList);


/***/ })

}]);